interface StartedLesson {
  id: number
  smartFileId: number
}

export interface StartedLessonsAPI {
  lessons: StartedLesson[]
}

const fetchStarted = async () => await useAuthFetch("v2/eklase/teacher/lessons/started")

export const useEklaseTeacherLessons = () => ({
  fetchStarted,
})
